export const JOIN_FB_GROUP = 'https://www.facebook.com/groups/impacthublearning/';
export const ASK_QUESTION = 'https://www.facebook.com/groups/impacthublearning/';
export const PARTNERSHIP = 'https://phnompenh.impacthub.net/partnership/';
export const FACEBOOK = 'https://www.facebook.com/groups/impacthublearning/';
export const EDEMY_WEB = 'https://edemy.org/';